import './isMobileFunction'

$(function () {
    $.fn.uiDropdownVal = function (value) {
        this.each(function () {
            var $self = $(this).val(value);
            var id = $self.data('dropdownid');
            if (id) {
                $(`div.ui-dropdown[data-dropdownid=${id}]`).text($('option:selected', $self).text());
            }
        });
    };

    uiDropdownJs();
});

function uiDropdownJs() {
    if (!window.isMobile()) {
        var id = 1;

        $(document).on('mouseenter.ui-d', 'select.ui-dropdown', function () {
            var $self = $(this);
            var selfId = id++;

            if (!$self.attr('data-dropdownid')) {
                $self.attr('data-dropdownid', selfId);
                /** replace `select` to div */
                var $selectedOption = $('option:selected', $self);
                var $container = $(`<div class="${$self[0].className}" data-dropdownid="${selfId}">${$selectedOption.text()}</div>`);
                $container.insertAfter($self);
                $self.hide();
                /** if select options elements updated */
                observeChanges($self, selfId);
                /** create div options */
                var $options = $('option', $self);
                var optionsHtml = '';
                $options.each(function (i, e) {
                    optionsHtml += `<div data-value="${e.value.replace(/"/g, '&quot;')}">${e.text}</div>`;
                })
                var itemsHtml = `<div class="ui-dropdown_items" data-dropdownid="${selfId}">${optionsHtml}</div>`;
                $('body').prepend(itemsHtml);
            }
        });

        /** open options */
        $(document).on('click.ui-d1', 'div.ui-dropdown', function () {
            var $self = $(this);
            var id = $self.data('dropdownid');
            var $options = $(`.ui-dropdown_items[data-dropdownid=${id}]`);
            if ($options.is(':visible') === false) {
                $('.ui-dropdown_items:visible').hide();
            }
            $options.css({
                top: $self.offset().top + $self.height(),
                left: $self.offset().left,
                width: $self.outerWidth()
            })
            $options.toggle();
        });

        /** close options, change real,fake value */
        $(document).on('click.ui-d2', function (e) {
            var $self = $(e.target);
            var optionValue = $self.data('value');
            if (optionValue !== undefined) {
                var $divOptions = $self.parent();
                if ($divOptions.hasClass('ui-dropdown_items')) {
                    var id = $divOptions.data('dropdownid');
                    var $selectDiv = $(`div.ui-dropdown[data-dropdownid=${id}]`);
                    var $realSelect = $(`select.ui-dropdown[data-dropdownid=${id}]`);
                    $selectDiv.text($self.text());
                    $realSelect.val(optionValue)
                    $realSelect.trigger('change');
                    $divOptions.hide();
                }
            } else {
                if ($self.hasClass('ui-dropdown') === false) {
                    $('.ui-dropdown_items').hide();
                }
            }
        });

        /** reset dropdown */
        $(document).on('click.ui-d3', '[type="reset"]', function () {
            var $self = $(this);
            var $form = $self.parents('form');
            if ($form.length) {
                setTimeout(function () {
                    var $divSelects = $('div.ui-dropdown', $form);
                    $divSelects.each(function (i, e) {
                        var $divSelect = $(e);
                        var $select = $divSelect.prev();
                        var $selectedOption = $('option:selected', $select);
                        $divSelect.text($selectedOption.text());
                    });
                }, 0);
            }
        });
    }
}

function observeChanges($self, selfId) {
    function updateSelectState(mutationsList, observer) {
        clearTimeout($self.waitModify);
        $self.waitModify = setTimeout(function () {
            if(observer) {
                observer.disconnect();
            } else {
                $self.off('DOMSubtreeModified.ui-d');
            }
            $self.removeAttr('data-dropdownid');
            $(`[data-dropdownid=${selfId}]`).remove();
            $self.show().trigger('mouseenter.ui-d');
        }, 200);
    }
    if(window.MutationObserver) {
        var observer = new MutationObserver(updateSelectState);
        observer.observe($self[0], {
            attributes: false,
            childList: true,
            subtree: false
        });
    } else {
        $self.on('DOMSubtreeModified.ui-d', updateSelectState);
    }
}
